import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState } from "recoil";
import pathState from "../../../../atoms/pathstate";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CompaniesData,
  CreateUser,
  DELETE_User,
  EDIT_User,
  GetBranchWithCompanyId,
  UserDataById,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import Button from "../../Button/Button";
import FirstSectionModal from "../../CommonMultiSelectComponent/FirstSelectionModal";
import { updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";
import { data } from "./AddUserEntry.config";
import "./AddUserEntry.scss";
import AddUserEntrySection from "./AddUserEntrySection/AddUserEntrySection";

const AddUserEntry = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction, Unique_Id }) => {
  const Form_Key = "User_Entry";
  const formRef = useRef({});
  const [{ CurrentTitle }] = useRecoilState(pathState);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const { popModal, getTopModal } = useModalContext();
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const FormData = useSelector((store) => store.FormFieldData);
  const fielddata = fielddataRedux?.User_Entry?.Selected_Row;
  const [toggle, settoggle] = useState(show ? show : false);
  const [alldata, setalldata] = useState({});
  const [allFieldsData, setAllFieldsData] = useState({});
  const [selectedBranches, setSelectedBranch] = useState({});
  const { data: getCompanyData } = useQuery(CompaniesData);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("All");
  const dispatch = useDispatch();

  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [createUser, { loading: createUserLoading }] = useMutation(CreateUser);

  const [getUserDataByID, { loading: getUserDataByIDLoader }] = useLazyQuery(UserDataById, {
    fetchPolicy: "network-only",
  });

  const [editUser, { loading: editUserLoading }] = useMutation(EDIT_User);

  const [DeleteUsers, { loading: DeleteUsersLoading }] = useMutation(DELETE_User);

  const UserEntryLoadingState = DeleteUsersLoading || editUserLoading || createUserLoading || getUserDataByIDLoader;

  useEffect(() => {
    setalldata(FormData.fielddata);
  }, [FormData]);

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      getFormSectionAndFields().then(() => {
        getUserDataByID({
          variables: {
            ID: fielddata?._id,
          },
        }).then(({ data }) => {
          let user = { ...data?.user[0] };
          let vehicleCategory = transformArrayToObj(data?.user[0]?.CompanyBranchRights);
          console.log(vehicleCategory, data?.user[0]?.CompanyBranchRights);
          setAllFieldsData(data?.user[0]);
          setSelectedBranch(vehicleCategory);
          setButtonLabel(determineButtonLabel(vehicleCategory));
          console.log(user, data?.user[0].Default_Branch);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Default_Company: { ...data?.user[0].Default_Company },
                Default_Branch: { ...data?.user[0].Default_Branch },
                Role: { ...user.Role },
                LR_Center: user?.LR_Center_Data,
              },
            },
          });
          user.Default_Company = user?.Default_Company?.Name;
          user.Default_Branch = user?.Default_Branch?.Name;
          user.Role = user?.Role?.Role;
          user.LR_Center = user?.LR_Center_Data?.Center_Name;
          setAllFieldsData(user);
          updateValueForm(formRef, user);
        });
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.User_Entry?.Selected_Rows);
  }, [fielddataRedux]);

  function transformArrayToObj(arr) {
    const result = {};
    arr?.forEach((item) => {
      result[item.Company_ID] = item.BranchAccess_Code.map((cat) => ({
        _id: cat,
      }));
    });
    return result;
  }

  const submit = async (close) => {
    const userId = allFieldsData?._id;
    let data = {};

    for (let key in alldata) {
      data = {
        ...data,
        ...alldata[key],
      };
    }

    let CompanyData = [];
    for (let key in selectedBranches) {
      if (selectedBranches?.hasOwnProperty(key)) {
        let branchCodes = selectedBranches[key]?.map((branch) => branch._id);

        CompanyData.push({ Company_ID: key, BranchAccess_Code: branchCodes });
      }
    }
    console.log(FormDataFromRedux?.MasterData[Form_Key]);
    const existingCompanyData = JSON.parse(localStorage.getItem("companyData")) || [];
    const updatedCompanyData = [...existingCompanyData, ...CompanyData];
    data.Default_Company = FormDataFromRedux?.MasterData[Form_Key]?.Default_Company?._id || null;
    data.Default_Branch = FormDataFromRedux?.MasterData[Form_Key]?.Default_Branch?._id || null;
    data.Role = FormDataFromRedux?.MasterData[Form_Key]?.Role?._id || null;
    data.LR_Center = FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?._id || null;
    delete data?.Group_Under;
    console.log(data);
    if (data.Password && data.Password !== data.Re_Type_Password && TypeOfPortal !== "Delete") {
      ErrorToast("Password not matching");
      return;
    }
    delete data.Re_Type_Password;
    switch (TypeOfPortal) {
      case "Edit":
        delete data.Re_Type_Password;
        console.log(data);
        if (CompanyData?.length) {
          data.CompanyData = CompanyData;
        }
        await editUser({
          variables: { id: userId, userInput: data },
        })
          .then((res) => {
            localStorage.setItem("companyData", JSON.stringify(updatedCompanyData));
            SuccessToast("Account Group Edited Successfully");
            Closeformfunction();
          })
          .catch((err) => {
            ErrorToast(err.message);
          });
        break;
      case "Delete":
        const ArrayOfID = selectedRows.map((obj) => obj?._id);

        await DeleteUsers({
          variables: { id: ArrayOfID[0] },
        })
          .then((res) => {
            const storedData = JSON.parse(localStorage.getItem("companyData"));
            if (storedData) {
              const updatedData = storedData.filter((item) => item._id !== ArrayOfID[0]);
              localStorage.setItem("companyData", JSON.stringify(updatedData));
            }
            if (CurrentTitle === Form_Key) {
              dispatch({ type: "Refetch", payload: true });
            }
            SuccessToast("User Deleted");
            settoggle(false);
            Closeformfunction();
          })
          .catch((err) => {
            ErrorToast(err.message);
          });
        break;
      default:
        data.CompanyData = CompanyData;
        await createUser({
          variables: {
            input: data,
          },
        })
          .then(() => {
            if (CurrentTitle === Form_Key) {
              dispatch({ type: "Refetch", payload: true });
            }
            localStorage.setItem("companyData", JSON.stringify(updatedCompanyData));
            SuccessToast("User Created Successfully...!");
            if (close === "close") {
              Closeformfunction();
            }
            setAllFieldsData({});
          })
          .catch((err) => {
            // settoggle(toggle);
            ErrorToast("Something went wrong! Please Check fields and try again.");
          });
        break;
    }
  };

  useEffect(() => {
    if (selectedBranches) {
      setButtonLabel(determineButtonLabel(selectedBranches));
    }
  }, [selectedBranches]);

  useEffect(() => {
    if (allFieldsData) {
      let transformedArray = allFieldsData?.CompanyBranchRights?.reduce((acc, item) => {
        let branchAccessIds = item?.BranchAccess_Code.map((code) => ({
          _id: code,
        }));
        return acc.concat(branchAccessIds);
      }, []);
    }
  }, [allFieldsData]);

  const Closeformfunction = () => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
    settoggle(false);
  };

  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            Closeformfunction();
          }}
          loadingState={UserEntryLoadingState}
        />
      </Reactportal>
    );
  }

  const handleAddCompaniesBranches = () => {
    setShowModal(true);
  };

  function determineButtonLabel(selectedBranches) {
    for (const key in selectedBranches) {
      if (selectedBranches[key]?.length >= 1) {
        return "Selected";
      }
    }
    return "All";
  }

  const footerContent = (
    <PortalFooter
      Form_key={Form_Key}
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      submitType={submitType === "Edit" ? false : submitType}
      SaveAndClose={() => {
        if (TypeOfPortal === "Add") {
          // Closeformfunction();
          submit("close");
        } else {
          submit("close");
        }
      }}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={UserEntryLoadingState}
    />
  );
  return (
    <div>
      <Reactportal
        Form_Key={Form_Key}
        FoooterContent={footerContent}
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal}
        TypeOfId={"Account Id :"}
        id={allFieldsData && allFieldsData.Unique_Id ? allFieldsData.Unique_Id : Unique_Id}
      >
        {UserEntryLoadingState && <div className="loader-line-div" />}
        <div className="UserEntryMainContainer">
          {inputFields?.length > 0 && (
            <div className="CompanyBranch">
              <p>Company</p>
              <Button action={handleAddCompaniesBranches} text={buttonLabel} name={"All"} />
              {showModal && (
                <FirstSectionModal
                  show={showModal}
                  query={GetBranchWithCompanyId}
                  getSelectedBranches={(data) => setSelectedBranch(data)}
                  selectedBranches={selectedBranches}
                  fielddata={selectedBranches}
                  data={getCompanyData && getCompanyData.GetAllCompanyMaster}
                  TypeOfPortal={"Select Company"}
                  setModal={() => setShowModal(false)}
                />
              )}
            </div>
          )}
          <div className="UserEntryContainer">
            {inputFields?.length > 0 ? (
              inputFields.map((e) => (
                <AddUserEntrySection
                  key={e.id}
                  inputfields={e.fields}
                  Type={e.name}
                  fielddata={allFieldsData}
                  TypeOfPortal={TypeOfPortal}
                  configData={data}
                  formkey={Form_Key}
                />
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p style={{ textAlign: "center" }}>No form fields available.</p>
            ) : null}
          </div>
        </div>
      </Reactportal>
    </div>
  );
};

export default AddUserEntry;
